import { ChangeDetectionStrategy, Component, input, output, signal, computed } from '@angular/core';
import { downgradeComponent } from '@angular/upgrade/static';
import App from '@app/app';
import { sanitizeInput } from '@app/utils/sanitize';
import { LtIconComponent } from '@app/components/core/lt-icon/lt-icon.component';

export type InputType = 'text' | 'tel' | 'email' | 'password';

@Component({
  selector: 'lt-text-input',
  templateUrl: './lt-text-input.component.html',
  imports: [LtIconComponent],
  styleUrl: './lt-text-input.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LtTextInputComponent {
  private static idCounter = 0;

  testId = input.required<string>();
  type = input<InputType>('text');
  label = input<string>('');
  placeholder = input<string>('');
  value = input<string>('');
  required = input<boolean>(false);
  disabled = input<boolean>(false);
  maxlength = input<number | null>(null);
  minLength = input<number | null>(null);
  error = input<string | null>(null);
  autocomplete = input<string>('off');
  showValidationIcon = input<boolean>(false);
  invalid = input<boolean>(false);
  staticLabel = input<boolean>(false);

  valueChange = output<string>();

  readonly inputId = `lt-text-input-${Math.random().toString(36).slice(2)}`;

  isFocused = signal(false);

  readonly effectiveValue = computed(() => sanitizeInput(this.value()));

  hasValue = computed(() => Boolean(this.effectiveValue()));
  hasLabel = computed(() => Boolean(this.label()));
  hasError = computed(() => Boolean(this.error()));

  onInput(event: Event): void {
    const target = event.target as HTMLInputElement;
    const value = sanitizeInput(target.value, '') ?? '';
    target.value = value;
    this.valueChange.emit(value);
  }

  onFocus(): void {
    this.isFocused.set(true);
  }

  onBlur(): void {
    this.isFocused.set(false);
  }
}

App.directive('ltTextInput', downgradeComponent({ component: LtTextInputComponent }));
